import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';

class ErrorService {

    reportError(error: DisguiseDto.VueLogDto) {
        // tslint:disable-next-line:no-console
        console.error(error);
        // todo: this will create an endlessly loop if no authorization is present. TRP-465
        HTTP_SERVICE_INSTANCE.getAxios().post('/logs/v0/logswebsite', error);
    }

}

const ERROR_SERVICE_INSTANCE = new ErrorService();

export {ERROR_SERVICE_INSTANCE};
